/* eslint-disable import/prefer-default-export */

import { getImage } from '@utils/imageHelper';

export const POINTS = [
  'Follow simple steps and get your rank',
  'Get estimated rank based on your marks',
  'Completely free'
];

export const IIT_JEE_POINTS = [
  'Get estimated rank based on your expected marks',
  'Follow simple steps and get your rank',
  'Completely free'
];

export const EXAMS = {
  NTAVDLBKV4: {
    min: -90,
    max: 720,
    name: 'NEET UG',
    heading: 'Enter your exam details',
    subHeading: 'Please enter your score and application number',
    scorePlaceholder: 'Enter your estimated NEET UG score'
  },
  V3O412F0LO: {
    min: -90,
    max: 300,
    name: 'IIT JEE',
    heading: 'Enter your exam details',
    subHeading: 'Please enter your score',
    scorePlaceholder: 'Enter your estimated IIT JEE score',
    buttonColor: 'light_dark',
    hasStartLearningCTA: true
  },
  AITS: {
    min: -90,
    max: 300,
    name: 'IIT JEE AITS',
    heading: 'Enter your exam details',
    subHeading: 'Please enter your score',
    scorePlaceholder: 'Enter your AITS score',
    buttonColor: 'light_dark',
    hasStartLearningCTA: true,
    applicationNumberPlaceholder: 'Enter your IIT JEE application number'
  },
  UNACADEMY: {
    min: -90,
    max: 300,
    name: 'IIT JEE',
    heading: 'Enter your exam details',
    subHeading: 'Please enter your score',
    scorePlaceholder: 'Enter your estimated JEE Main score',
    buttonColor: 'light_dark',
    hasStartLearningCTA: true,
    applicationNumberPlaceholder: 'Enter your JEE Main application number'
  }
};

export const BENEFITS = [
  {
    img: 'top_educators.svg',
    heading: 'India’s best educators',
    subtext:
      'Learn live with India’s best educators and kick-start your preparation journey'
  },
  {
    img: 'complete_syllabus.svg',
    heading: 'Complete syllabus coverage',
    subtext:
      'All courses and batches are structured to help you complete the syllabus on time'
  },
  {
    img: 'doubts-tests.svg',
    heading: 'Live doubt solving and tests',
    subtext:
      'Boost your preparation with our regular mock tests and get detailed performance analysis'
  }
];

export const IIT_JEE_BENEFITS = [
  {
    img: getImage('top_educators_dark.svg'),
    heading: 'India’s best educators',
    subtext:
      'Learn live with India’s best educators and kick-start your preparation journey'
  },
  {
    img: getImage('complete_syllabus_dark.svg'),
    heading: 'Complete syllabus coverage',
    subtext:
      'All courses and batches are structured to help you complete the syllabus on time'
  },
  {
    img: getImage('doubts-tests_dark.svg'),
    heading: 'Live doubt solving and tests',
    subtext:
      'Boost your preparation with our regular mock tests and get detailed performance analysis'
  }
];

export const VALIDATIONS = {
  maxLength: 12,
  minDate: 978307200000, // 2001-01-01
  maxDate: 1293753600000 // 2010-12-31'
};

export const NEET_VALIDATIONS = {
  maxLength: 12,
  minDate: 631132200000, // 1990-01-01
  maxDate: 1451500200000 // 2015-12-31'
};

export const RANK_PREDICTION_PAGE_VIEWED = 'Rank prediction - page viewed';
export const PREDICTED_RANK_START_LEARNING_CLICKED =
  'Rank Prediction - Start Learning Clicked';
export const PREDICT_NOW_CLICKED = 'Rank Prediction - Predict Now Clicked';

export const GATE_UID = 'GATE';

export const GATE_META_INFO = {
  title: 'Gate Rank Predictor',
  description: 'Get estimated gate rank based on your expected marks'
};

export const FAQ_YOTUH = [
  {
    question: 'Where can I get the Rank Predictor?',
    answer:
      'You can scan the QR code or you can click on the link to get the most accurate NEET-UG 2023 rank Predictor by Unacademy. https://unacademy.com/rankpredictor/neet-rank-predictor/YOTUH'
  },
  {
    question: 'How can I use the Rank Predictor?',
    answer:
      'You need to enter your details and then click on `Predict my Rank`.'
  },
  {
    question: 'Is there any fee to use the Rank Predictor on Unacademy?',
    answer: 'No, the Unacademy’s NEET-UG  2023 Rank Predictor is free to use.'
  },
  {
    question:
      'Where can I check the list of all the medical colleges in India?',
    answer:
      'You can visit the official website of NATIONAL MEDICAL COMMISSION to get the list of all the medical institutions of India along with the annual intake of seats.'
  },
  {
    question: 'What are the lists of courses available after clearing NEET-UG?',
    answer:
      'Authorities grant admission to MBBS, BDS, BAMS, BYNS, BUMS, BSMS, BHMS, BVSc & AH, nursing courses through NEET scores.'
  }
];
